import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';

import { AskHrChatFeatureId } from '@core/ask-hr-types';
import { HeaderThreadComponent, HrAssistantChatFeatureService } from '@core/intelligence-smart-ui';

import { ChatRequestFormComponent } from '../chat-request-form/chat-request-form.component';

@Component({
  selector: 'tlc-chat-request-form-feature',
  template: `
    <tlc-chat-header-thread (back)="backToWelcome()" (close)="onClose()" />
    @if (templateId(); as id) {
      <ask-chat-request-form
        [templateId]="id"
        (cancelClick)="backToWelcome()"
        (submitted)="onSubmitted()"
      />
    }
  `,
  imports: [HeaderThreadComponent, ChatRequestFormComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './chat-request-form-feature.component.less',
})
export class ChatRequestFormFeatureComponent {
  private readonly hrAssistantFeaturesService = inject(HrAssistantChatFeatureService);

  protected templateId = input<number>();

  protected onClose() {
    this.hrAssistantFeaturesService.close$.next();
  }

  protected backToWelcome() {
    this.hrAssistantFeaturesService.clearFeature();
  }

  protected onSubmitted() {
    this.hrAssistantFeaturesService.setFeatureById(AskHrChatFeatureId.Tickets);
  }
}
